// extracted by mini-css-extract-plugin
module.exports = {"EmployeeDataContainer":"EmployeeData__EmployeeDataContainer___3azXk"};